import React, { FC } from 'react';
import cls from 'classnames';
import LoaderIndeterminateCircular from '../../loader/loaderIndeterminateCircular/LoaderIndeterminateCircular';

import { ButtonStandardProps } from './ButtonStandard.types';
import { Theme } from '../../../../../tailwind/src/theme';

const loaderColorMap: { [key: string]: keyof Theme['colors'] } = {
	primary: 'onPrimaryFixed',
	secondary: 'onSurfaceVariant',
	tertiary: 'secondary',
	outline: 'onSurfaceVariant',
	inverseHighlight: 'onSurface',
	inverseSecondary: 'inverseOnSurface',
};

const ButtonStandard: FC<ButtonStandardProps> = (props) => {
	const {
		loading,
		variant = 'primary',
		size = 'large',
		className,
		disabled,
		leftIcon,
		rightIcon,
		children,
		...buttonProps
	} = props;
	const LeftIcon = leftIcon;
	const RightIcon = rightIcon;

	const loaderSize = size === 'large' || 'XL' ? 'medium' : 'small';
	const loaderFill = loaderColorMap[variant];

	return (
		<button
			className={cls('button-standard', variant, size, loading && 'loading', className)}
			disabled={disabled || loading}
			{...buttonProps}
		>
			{LeftIcon ? <LeftIcon className="leftIcon" size="2XS" /> : null}
			<span>{children}</span>
			{RightIcon ? <RightIcon className="rightIcon" size="2XS" /> : null}
			{loading && (
				<div className="loading-container">
					<LoaderIndeterminateCircular size={loaderSize} fill={loaderFill} />
				</div>
			)}
		</button>
	);
};

ButtonStandard.displayName = 'ButtonStandard';

export default ButtonStandard;
